import { render, staticRenderFns } from "./TextEditor.vue?vue&type=template&id=19583572&scoped=true&"
import script from "./TextEditor.vue?vue&type=script&lang=js&"
export * from "./TextEditor.vue?vue&type=script&lang=js&"
import style0 from "./TextEditor.vue?vue&type=style&index=0&id=19583572&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19583572",
  null
  
)

export default component.exports